import {Component, OnInit} from '@angular/core';
import { ModalController } from '@ionic/angular';
import {DateUtils} from "../../../_helpers/date-utils";

@Component({
    selector: 'app-select-date-range',
    templateUrl: './select-date-range.component.html',
    styleUrls: ['./select-date-range.component.scss'],
    standalone: false
})
export class SelectDateRangeComponent implements OnInit {
  singleDate = false;
  startDate = '';
  endDate = '';
  activePreset = '';
  selectedDate: string;
  step = 0;
  constructor(
    private modalController: ModalController) { }

  ngOnInit() {
    this.selectedDate = this.startDate;
    this.step = 1;
  }

  confirm = () => this.modalController.dismiss({startDate: this.startDate, endDate: this.endDate }, 'confirm');
  cancel = () => this.modalController.dismiss(null, 'cancel');

  // ---------- Utils ----------
  private todayLocal(): Date {
    return new Date();
  }

  private assignRange(startLocal: Date, endLocal: Date, setHours = false) {
    let start = startLocal;
    let end = endLocal;
    if (!setHours) {
      start = DateUtils.startOfDayLocal(startLocal);
      end = DateUtils.endOfDayLocal(endLocal);
    }
    this.startDate = DateUtils.toUtcIso(start);
    this.endDate = DateUtils.toUtcIso(end);
  }

  clearPresetSelection() {
    this.activePreset = '';
  }

  // ---------- Base ----------
  setLastHour() {
    this.activePreset = 'lastHour';
    const now = new Date();
    const start = new Date(now);
    start.setHours(now.getHours() - 1);

    this.assignRange(start, now, true);
  }

  setLast2Hours() {
    this.activePreset = 'last2Hours';
    const now = new Date();
    const start = new Date(now);
    start.setHours(now.getHours() - 2);

    this.assignRange(start, now, true);
  }

  setLast4Hours() {
    this.activePreset = 'last4Hours';
    const now = new Date();
    const start = new Date(now);
    start.setHours(now.getHours() - 4);

    this.assignRange(start, now, true);
  }
  
  setToday() {
    this.activePreset = 'today';
    const today = this.todayLocal();
    this.assignRange(today, today);
  }

  setCurrentWeek() {
    this.activePreset = 'currentWeek';
    const today = this.todayLocal();
    const day = today.getDay() || 7; // lunedì = 1
    const start = new Date(today);
    start.setDate(today.getDate() - day + 1);

    const end = new Date(start);
    end.setDate(start.getDate() + 6);

    this.assignRange(start, end);
  }

  setCurrentMonth() {
    this.activePreset = 'currentMonth';
    const now = this.todayLocal();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    this.assignRange(start, end);
  }

  // ---------- FISCALI ----------
  setFiscalYear() {
    this.activePreset = 'fiscalYear';
    const year = this.todayLocal().getFullYear();
    const start = new Date(year, 0, 1);
    const end = new Date(year, 11, 31);

    this.assignRange(start, end);
  }

  setLastFiscalYear() {
    this.activePreset = 'lastFiscalYear';
    const year = this.todayLocal().getFullYear() - 1;
    const start = new Date(year, 0, 1);
    const end = new Date(year, 11, 31);

    this.assignRange(start, end);
  }

  setCurrentQuarter() {
    this.activePreset = 'currentQuarter';
    const now = this.todayLocal();
    const quarter = Math.floor(now.getMonth() / 3);
    const startMonth = quarter * 3;

    const start = new Date(now.getFullYear(), startMonth, 1);
    const end = new Date(now.getFullYear(), startMonth + 3, 0);

    this.assignRange(start, end);
  }

  // ---------- Rolling ----------
  setLastMonth() {
    this.activePreset = 'lastMonth';
    const end = this.todayLocal();
    const start = new Date(end);
    start.setMonth(start.getMonth() - 1);

    this.assignRange(start, end);
  }

  setLast12Months() {
    this.activePreset = 'last12Months';
    const end = this.todayLocal();
    const start = new Date(end);
    start.setMonth(start.getMonth() - 12);

    this.assignRange(start, end);
  }

}
